import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';
import { Mutation } from 'react-apollo';

import { name , description, phone ,validateForm , yearsOfEx , email} from '../../../validations/validation';


//styles and icons 
import { Paper, Button, TextField, InputLabel, Typography, FormControl, Select } from '@material-ui/core';
import { Row, Col, Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import profileIcon from '../../../images/personal.svg';
import Skeleton from '@material-ui/lab/Skeleton';

// this component represent the profile part in explore opportunities page 

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCountryId: '',
            errors : {
                name : '',
                headline : '',
                yearsOfEx : '',
                email : '',
                phone : '',
                address : ''
            }
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {

            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            const id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `query($user_id : Int !){
                        user(id: $user_id){
                        id
                        name
                        email
                        image
                        is_active
                        is_verified
                        created_at
                        updated_at
                        my_bio{
                            title
                            speciality{
                                name
                            }
                            created_at
                            video{
                            duration 
                            frame{
                                url
                            }
                            url
                            }
                        }
                        Locale
                        address
                        image
                        cities_id
                        countries_id
                        phone
                        headlines
                        date_of_birth
                        bio
                        years_of_experience
                        profile_image{
                            url
                        }
                        profile_pdf{
                            url
                        }
                  }
              }
       `, variables: { user_id: id }
            }).then(res => {
                //get all countries and cities data
                apolloFetch({
                    query:
                        ` query{
                        countries{
                            id
                            name
                            cities{
                            name
                            id
                            }
                        }
                        }
            `,
                }).then(result => {
                    console.log(result);
                    let country = result.data.countries.filter(country => country.id === res.data.user.countries_id)
                    let city = country[0].cities.filter(city => city.id === res.data.user.cities_id)

                    this.props.callBackProp(res.data.user)
                    this.setState({ ...this.state, userData: res.data.user, countries: result.data.countries, country: country[0], cities: country[0].cities, city: city[0] })
                });
            });

        }
    }
    componentWillMount() {
        this.getUserData();
        this.getYesterday();
    }
    getYesterday = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0') - 1;
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;
        console.log(today);
        this.setState({ ...this.state, today: today });
    }
    handleOnchangeCountry = (e) => {
        let selectedCountryId = e.target.value;
        let country = this.state.countries.filter(country => country.id === selectedCountryId);
        let currentCityId = document.querySelector('.city input').value;
        let city = country[0].cities.filter(city => city.id === parseInt(currentCityId));

        if (city.length === 0) {
            document.querySelector('.city div').classList.add('border', 'border-danger');

            this.setState({ ...this.state, cities: country[0].cities, cityErorr: true })
        }
        else {
            document.querySelector('.city div').classList.remove('border', 'border-danger');
            this.setState({ ...this.state, cities: country[0].cities, cityErorr: false })

        }
    }
    handleOnChange = (props) => event => {
        this.setState({...this.state , [props] : event.target.value});
        let errors = this.state.errors;
        console.log(props , event.target.value);
        switch (props) {
            case 'name':
                errors.name = name(event.target.value)
                break;
            case 'headlines':
                errors.headlines = name(event.target.value)
                break; 
            case 'yearsOfEx':
                errors.yearsOfEx = yearsOfEx(event.target.value)
                break; 
            case 'email':
                errors.email = email(event.target.value)
                break;
            case 'phone':
                errors.phone = phone(event.target.value)
                break; 
            case 'address':
                errors.address = description(event.target.value)
                break;            
            default:
                break;
        }
        console.log(errors)
    }
    closeProfileEdit = () => this.setState({
        ...this.state, showProfileEdit: false,
        PhoneErrorMessage: '', nameErrorMessage: '',
        addressErrorMessage: '', headlinesErrorMessage: ''
    })
    render() {
        if (!this.state.userData) {
            return (
                <div>
                    <Skeleton animation="wave" width={170} height={40} />
                    <Skeleton className="mb-2" variant="rect" animation="wave" height={360} />
                </div>
            )
        }
        else {
        console.log(this.state.userData);
            return (
                <div className="profile">
                    <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0" xs={8}>
                                        <h6 className="bold mb-0">
                                            <span ><img src={profileIcon} alt="icon" className="pr-3 pb-1" /></span>
                                            Personal info</h6>
                                    </Col>
                                    <Col className="text-right p-0" xs={4}>
                                        <button
                                            className="bg-transparent border-0"
                                            onClick={e =>
                                                this.setState({ ...this.state, showProfileEdit: true })}
                                        >
                                            <h6>Edit</h6>
                                        </button>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Name</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.name) ? this.state.userData.name : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Headlines</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.headlines) ? this.state.userData.headlines : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Years of experience</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.years_of_experience) ? this.state.userData.years_of_experience : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Email address</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.email) ? this.state.userData.email : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Phone number</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.phone) ? this.state.userData.phone : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Country</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.country) ? this.state.country.name : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">City</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.city) ? this.state.city.name : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Address</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.address) ? this.state.userData.address : ''}</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 bg-lightgrey p-2 mb-2">
                                    <Col md={4}>
                                        <p className="mb-0">Date of birth</p>
                                    </Col>
                                    <Col md={8} className="p-0">
                                        <p className="mb-0">{(this.state.userData.date_of_birth) ? this.state.userData.date_of_birth : ''}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Modal
                                size="md"
                                centered
                                className="row m-0  pr-0"
                                show={this.state.showProfileEdit}
                                onHide={this.closeProfileEdit}>
                                <Col xs={12} className="p-0">
                                    <Modal.Header className="p-2 pr-3 pl-3 bg-lightgrey" closeButton>
                                        <Modal.Title className="h5 ">Personal Info</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="p-4">
                                        {/* name */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="name">
                                                <p className="mb-1"> Name</p>
                                            </InputLabel>
                                            <TextField
                                                required
                                                id="name"
                                                name="name"
                                                defaultValue={this.state.userData.name}
                                                onChange={this.handleOnChange('name')}
                                                className="p-0"
                                                placeholder="Write your name"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.name}</Typography>
                                            </Col>
                                        </div>
                                        {/* headlines */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="name">
                                                <p className="mb-1">Headlines</p>
                                            </InputLabel>
                                            <TextField
                                                id="headlines"
                                                name="headlines"
                                                onChange={this.handleOnChange('headlines')}
                                                defaultValue={this.state.userData.headlines}
                                                className="p-0"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.headlines}</Typography>
                                            </Col>
                                        </div>
                                        {/* years of ex */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="name">
                                                <p className="mb-1">Years of experience</p>
                                            </InputLabel>
                                            <TextField
                                                id="yearsEx"
                                                name="yearsEx"
                                                type="number"
                                                inputProps={{
                                                    min: '1',
                                                    max: '15'
                                                }}
                                                defaultValue={this.state.userData.years_of_experience}
                                                className="p-0"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                onChange={this.handleOnChange('yearsOfEx')}
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.yearsOfEx}</Typography>
                                            </Col>
                                        </div>
                                        {/* phone number */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="tel">
                                                <p className="mb-1">Phone number </p>
                                            </InputLabel>
                                            <TextField
                                                required
                                                id="tel"
                                                name="tel"
                                                type="tel"
                                                defaultValue={this.state.userData.phone}
                                                onChange={this.handleOnChange('phone')}
                                                className="p-0"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.phone}</Typography>
                                            </Col>
                                        </div>
                                        {/*country and city*/}
                                        <div className="row m-0 mb-3">
                                            <Col className="p-0 pr-2">
                                                <InputLabel className="mb-1" htmlFor="country-select">
                                                    Country
                                                </InputLabel>
                                                <FormControl size="small" id="country-select" fullWidth variant="outlined">
                                                    <Select
                                                        className="country"
                                                        onChange={e => this.handleOnchangeCountry(e)}
                                                        defaultValue={(this.state.country) ? this.state.country.id : ''}
                                                    >
                                                        {(this.state.countries) ?
                                                            this.state.countries.map(country => {
                                                                return (
                                                                    <option value={country.id}>{country.name}</option>
                                                                );
                                                            }) : ''
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Col>
                                            <Col className="p-0">
                                                <InputLabel className="mb-1" htmlFor="city-select">
                                                    City
                                            </InputLabel>
                                                <FormControl size="small" id="city-select" fullWidth variant="outlined">
                                                    <Select
                                                        className="city"
                                                        defaultValue={(this.state.city) ? this.state.city.id : ''}
                                                        onChange={e => {
                                                            document.querySelector('.city div').classList.remove('border', 'border-danger');
                                                            this.setState({ ...this.state, cityErorr: false })
                                                        }}
                                                    >
                                                        {
                                                            this.state.cities.map(city => {
                                                                return (
                                                                    <option value={city.id}>{city.name}</option>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Col>
                                        </div>
                                        {/* address */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="address">
                                                <p className="mb-1"> Address </p>
                                            </InputLabel>
                                            <TextField
                                                required
                                                id="address"
                                                name="address"
                                                defaultValue={this.state.userData.address}
                                                onChange={this.handleOnChange('address')}
                                                className="p-0"
                                                placeholder="Write your name"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.address}</Typography>
                                            </Col>
                                        </div>
                                        {/* date if birth */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="date">
                                                <p className="mb-1"> Date of birth </p>
                                            </InputLabel>
                                            <TextField
                                                required
                                                type="date"
                                                id="date"
                                                name="date"
                                                defaultValue={this.state.userData.date_of_birth}
                                                inputProps={{
                                                    max: this.state.today
                                                }}
                                                className="p-0"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer className="custom pt-3 pr-3 pl-3 border-0">
                                        <Row className="m-0 w-100">
                                            <Col xs={6} className="text-left p-0">
                                                <Button
                                                    type="button"
                                                    size="large"
                                                    className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                    onClick={() => {
                                                        this.closeProfileEdit();
                                                    }}>
                                                    Cancel
                                                    </Button>
                                            </Col>
                                            <Col xs={6} className="text-right p-0">
                                                <Mutation mutation={SAVE_DATA}>
                                                    {(Userupdate, { data, loading }) =>
                                                        <div>
                                                            <Button
                                                                type="submit"
                                                                size="large"
                                                                className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                                onClick={() => {
                                                                    let name = document.querySelector('#name').value;
                                                                    let headlines = document.querySelector('#headlines').value;
                                                                    let yearsOfEx = document.querySelector('#yearsEx').value;
                                                                    let PhoneNumber = document.querySelector('#tel').value;
                                                                    let country = document.querySelector('.country input').value;
                                                                    let city = document.querySelector('.city input').value;
                                                                    let address = document.querySelector('#address').value;
                                                                    let dob = document.querySelector('#date').value;
                                                                    console.log(document.querySelector('.city input'))
                                                                    if (city === '') {
                                                                        document.querySelector('.city div').classList.add('border', 'border-danger')
                                                                    }
                                                                    else if (!this.state.cityErorr && validateForm(this.state.errors)) {
                                                                        Userupdate({
                                                                            variables: {
                                                                                name: name,
                                                                                headlines: headlines,
                                                                                phone: PhoneNumber,
                                                                                date_of_birth: dob,
                                                                                address: address,
                                                                                cities_id: city,
                                                                                countries_id: country,
                                                                                years_of_experience: yearsOfEx
                                                                            }
                                                                        }).then((res, loading) => {
                                                                            if (res.data.Userupdate.Status.code === 200) {
                                                                                this.getUserData();
                                                                                this.closeProfileEdit();
                                                                            }

                                                                        }).catch((err) => console.log(err));
                                                                    }
                                                                }}
                                                            >
                                                                Save
                                                        </Button>
                                                            {loading &&
                                                                <div className="loading">
                                                                    {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                    <Loader
                                                                        type="TailSpin"
                                                                        color="white"
                                                                        height={50}
                                                                        width={50}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </Mutation>
                                            </Col>
                                        </Row>
                                    </Modal.Footer>
                                </Col>
                            </Modal>
                        </Row>
                    </Paper>
                </div>
            );
        }
    }
}
const SAVE_DATA = gql`
mutation($name : Name $headlines : Title $phone : Title $date_of_birth : Date  $address : Text $cities_id : Int 
    $countries_id : Int $years_of_experience :Int
  ){
    Userupdate(data:{
      name : $name
      headlines : $headlines
      phone : $phone
      date_of_birth : $date_of_birth 
      address : $address
      cities_id : $cities_id
      countries_id : $countries_id
      years_of_experience : $years_of_experience
      
    }){
        user{ id
            name
            email
            image
            is_active
            is_verified
            created_at
            updated_at
            my_bio{
                title
                speciality{
                    name
                }
                created_at
                video{
                duration 
                frame{
                    url
                }
                url
                }
            }
            Locale
            address
            image
            cities_id
            countries_id
            phone
            headlines
            date_of_birth
            bio
            years_of_experience
            profile_image{
                url
            }
            profile_pdf{
                url
            }
        }
      Status{
        code
      }
    }
  }
`;

export default compose(
    graphql(SAVE_DATA, {
        name: 'saveData'
    })
)(withRouter(Profile))